import Vue from 'vue'
import select from 'select-dom'
import ZoomOnHover from 'vue-zoom-on-hover'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin/dist/photoswipe-video-plugin.esm.js'
import 'photoswipe/style.css'

Vue.use(ZoomOnHover)
const CLASS_ACTIVE = 'active'

Vue.component('product-gallery', {
  props: ['product', 'showVideoVolumeButton'],
  data () {
    return {
      swiperTop: null,
      activeSlide: 0,
      showVolumeButton: this.showVideoVolumeButton === 'true',
      lightbox: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swiperTop = select('.swiper', this.$refs.mainCarousel.$el).swiper

      this.addThumbnailEvents()
      this.initGalleryLightBox()
    })
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  },
  methods: {
    initGalleryLightBox () {
      if (!this.lightbox) {
        this.lightbox = new PhotoSwipeLightbox({
          gallery: this.$refs.productGalleryLightBox,
          children: 'a',
          pswpModule: () => import('photoswipe')
        })
        const videoPlugin = new PhotoSwipeVideoPlugin(this.lightbox)
        this.lightbox.init()

        this.lightbox.on('change', () => {
          const { pswp } = this.lightbox
          setTimeout (() =>{
            this.$refs.mainCarousel.swiper.slideTo(pswp.currIndex, 0, false)
          }, 500)
        })
      }
    },
    addThumbnailEvents() {
      const thumbnailEls = document.querySelectorAll(
        '.product-gallery__thumbnails .swiper-slide'
      )
      if (thumbnailEls.length > 0) {
        thumbnailEls[0].classList.add(CLASS_ACTIVE)
        for (let index = 0; index < thumbnailEls.length; index++) {
          thumbnailEls[index].addEventListener('click', () => {
            this.pauseVideos()
          })
        }
      }
    },
    pauseVideos() {
      const youtubeVideos = this.$el.querySelectorAll('iframe')
      const videos = this.$el.querySelectorAll('video')
      if (youtubeVideos || videos) {
        if (youtubeVideos && youtubeVideos.length > 0) {
          youtubeVideos.forEach((item) => {
            item.$refs.video.player.pauseVideo()
          })
        }
        if (videos && videos.length > 0) {
          videos.forEach((item) => {
            const video = item.parentNode.__vue__
            video.pauseVideo()
          })
        }
      }
    },
    getIdYoutube(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      const match = url.match(regExp)
      return match && match[7].length === 11 ? match[7] : false
    },
    srcVideo(sources) {
      const mp4Sources = sources.filter((s) => s.format === 'mp4')
      const hdMp4Source = mp4Sources.find(
        (s) => s.height >= 1080 || s.width >= 1080
      )

      return hdMp4Source ? hdMp4Source.url : mp4Sources[0].url
    },
  }
})